var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
library.add(fas);
library.add(fal);
export var Icon = function Icon(_ref) {
  var type = _ref.type,
    fixedWidth = _ref.fixedWidth,
    style = _ref.style,
    className = _ref.className,
    faStyle = _ref.faStyle;
  return /*#__PURE__*/React.createElement(IconContainer, {
    width: fixedWidth,
    style: style,
    className: className
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: [faStyle ? faStyle : 'fal', type],
    size: "lg"
  }));
};
var IconContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  text-align: center;\n  display: inline-block;\n  margin-top: -2px;\n"])), function (p) {
  return p.width;
});
export default Icon;